<template>
  <footer class="app-footer">
    <div class="container">
      <div class="footer-top">
        <router-link to="/" class="footer-logo">
          <img :src="siteLogo" :alt="siteConfig.companyName" />
        </router-link>

        <nav class="footer-nav">
          <nav-link
            v-for="item in footerNavItems"
            :key="item.megaMenuKey || item.path"
            :to="item.path"
            :href="item.href"
            :external="item.external"
          >
            {{ item.name }}
          </nav-link>
        </nav>
      </div>

      <div class="footer-divider"></div>

      <div class="footer-info">
        <div class="footer-contact">
          <p>
            <i class="el-icon-location-outline"></i>
            {{ siteAddress }}
          </p>
          <p>
            <i class="el-icon-phone-outline"></i>
            联系电话：{{ sitePhone }}
          </p>
          <p>
            <i class="el-icon-message"></i>
            {{ siteEmail }}
          </p>
        </div>

        <div class="footer-qr">
          <div class="qr-divider"></div>
          <div class="qr-box">
            <img :src="consultQrImg" alt="扫码关注" />
            <p>扫一扫，关注一下</p>
          </div>
        </div>

        <div v-if="siteCopyright || siteIcp" class="footer-bottom">
          <span v-if="siteCopyright" class="footer-copyright">{{ siteCopyright }}</span>
          <a
            v-if="siteIcp"
            class="footer-icp"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              class="footer-gongan"
              src="https://cms.mz-demo-static.tecmz.com/vendor/Site/image/gongan.png?2817422880"
              alt=""
            />
            {{ siteIcp }}
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { siteConfig } from '@/data/site'
import { mapGetters } from 'vuex'
import NavLink from '@/components/common/NavLink.vue'
import { fetchConfigSetting } from '@/api/anqicms'
import consultQrImg from '@/assets/images/consult-qrcode.png'
import siteLogo from '@/assets/images/site-logo.png'

export default {
  name: 'AppFooter',
  components: { NavLink },
  data() {
    return {
      siteConfig,
      consultQrImg,
      siteLogo,
      configData: null
    }
  },
  computed: {
    ...mapGetters(['headerNavItems']),
    footerNavItems() {
      return this.headerNavItems.filter(item => item.path !== '/')
    },
    siteCopyright() {
      return (this.configData && this.configData.SiteCopyright) || ''
    },
    siteIcp() {
      return (this.configData && this.configData.SiteIcp) || ''
    },
    siteEmail() {
      return (this.configData && this.configData.Email) || ''
    },
    sitePhone() {
      return (this.configData && this.configData.Phone) || ''
    },
    siteAddress() {
      return (this.configData && this.configData.Adress) || ''
    },
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    async loadConfig() {
      try {
        const res = await fetchConfigSetting()
        if (res.code === 0) {
          this.configData = res.data
        }
      } catch (e) {
        console.warn('获取配置失败', e.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-footer {
  background: linear-gradient(
    90deg,
    rgba(111, 101, 249, 1) 0%,
    rgba(90, 139, 252, 1) 50%,
    rgba(64, 182, 255, 1) 100%
  );
  color: $white;
  padding: 48px 0 40px;
}

.footer-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.footer-logo {
  flex-shrink: 0;

  img {
    height: 48px;
    width: auto;
    display: block;
    mix-blend-mode: lighten;
  }
}

.footer-nav {
  display: flex;
  align-items: center;
  gap: 48px;

  ::v-deep a {
    font-size: 15px;
    color: $white;
    white-space: nowrap;
    transition: $transition;

    &:hover {
      opacity: 0.85;
    }
  }
}

.footer-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
  margin: 32px 0;
}

.footer-info {
  display: flex;
  align-items: center;
  gap: 40px;
}

.footer-bottom {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-left: auto;
  font-size: 13px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.85);
  text-align: center;
}

.footer-copyright {
  white-space: nowrap;
}

.footer-icp {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: rgba(255, 255, 255, 0.85);
  transition: $transition;

  &:hover {
    color: $white;
    opacity: 0.95;
  }
}

.footer-gongan {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  vertical-align: middle;
}

.footer-contact {
  p {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    line-height: 2.2;
    color: rgba(255, 255, 255, 0.95);

    i {
      font-size: 16px;
      flex-shrink: 0;
    }
  }
}

.footer-qr {
  display: flex;
  align-items: center;
  gap: 32px;
  flex-shrink: 0;
}

.qr-divider {
  width: 1px;
  height: 80px;
  background: rgba(255, 255, 255, 0.3);
}

.qr-box {
  text-align: center;

  img {
    width: 80px;
    height: 80px;
    display: block;
    border-radius: 4px;
    background: $white;
    padding: 4px;
  }

  p {
    margin-top: 8px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.9);
    white-space: nowrap;
  }
}

@media (max-width: 992px) {
  .footer-top {
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-nav {
    flex-wrap: wrap;
    gap: 24px 32px;
  }
}

@media (max-width: 768px) {
  .app-footer {
    padding: 32px 0 28px;
  }

  .footer-divider {
    margin: 24px 0;
  }

  .footer-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }

  .footer-qr {
    width: 100%;
    justify-content: flex-start;
  }

  .qr-divider {
    display: none;
  }

  .footer-bottom {
    flex: none;
    width: 100%;
    margin-left: 0;
    align-items: center;
    text-align: center;
  }

  .footer-copyright {
    white-space: normal;
  }
}
</style>
